import type { FunctionalGroup, UserInfo } from "types/user";

import { apiClient } from "../apiClient";

export const getGroups = (caseType?: string) =>
  apiClient.get<FunctionalGroup[]>(
    caseType ? `/groups?caseType=${encodeURIComponent(caseType)}` : "/groups",
  );

export const getLiteras = () =>
  apiClient.get<string[]>("/lookups/fordonslittera");

export const getFbsValues = () => apiClient.get<string[]>("/lookups/fbs");

export const getMe = () => apiClient.get<UserInfo>("/me");
